<div class="row my-5 px-3">
    <div class="col-12">
        <div class="shadow-wrapper">
            <div>
                <h2 class="py-3 px-2">{{ translation.t('officerComplaints', 'closedTitle') }}</h2>
            </div>
            <div class="px-2" *ngIf="allComplaints.length > 0; else noData">
                <!-- Export buttons row -->
                <div class="d-flex justify-content-end gap-2 mb-2" *ngIf="complaints.data.length > 0">
                    <button class="btn btn-success" (click)="exportToExcel()" style="background-color: #1D6F42; border-color: #1D6F42; height: 36px;">
                        <i class="fa fa-file-excel-o"></i> {{ translation.t('officerComplaints', 'excel') }}
                    </button>
                    <button class="btn btn-danger" (click)="exportToPDF()" style="background-color: #f44336; border-color: #f44336; height: 36px;">
                        <i class="fa fa-file-pdf-o"></i> {{ translation.t('common', 'pdf') }}
                    </button>
                </div>
                <!-- Filter row -->
                <div class="d-flex flex-wrap gap-2 align-items-end mb-3">
                    <div class="flex-grow-1" style="min-width: 200px;">
                        <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('officerComplaints', 'searchPlaceholder') }}</label>
                        <input type="text" class="form-control fontAwesome w-100" style="padding: 8px;" [(ngModel)]="searchText" [placeholder]="translation.t('officerComplaints', 'searchPlaceholder')">
                    </div>
                    <div class="flex-grow-1" style="min-width: 200px;">
                        <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('common','fromDate') }}</label>
                        <input type="date" class="form-control w-100" style="padding: 8px;" [(ngModel)]="fromDate" [max]="toDate">
                    </div>
                    <div class="flex-grow-1" style="min-width: 200px;">
                        <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('common','toDate') }}</label>
                        <input type="date" class="form-control w-100" style="padding: 8px;" [(ngModel)]="toDate" [min]="fromDate">
                    </div>
                    <div class="flex-grow-1" style="min-width: 200px;">
                        <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('officerComplaints', 'zone') }}</label>
                        <ng-select [(ngModel)]="selectedZone" [items]="uniqueZones" [placeholder]="translation.t('adminDashboard', 'allZones')" [clearable]="true" [searchable]="true"></ng-select>
                    </div>
                    <div class="flex-grow-1" style="min-width: 200px;">
                        <label style="font-size: 13px; font-weight: 500; margin-bottom: 4px;">{{ translation.t('officerComplaints', 'department') }}</label>
                        <ng-select [(ngModel)]="selectedDept" [items]="uniqueDepartments" [placeholder]="translation.t('adminDashboard', 'selectDepartment')" [clearable]="true" [searchable]="true"></ng-select>
                    </div>
                    <div class="flex-grow-0">
                        <label style="height: 19px; margin-bottom: 4px; display: block;">&nbsp;</label>
                        <div class="d-flex gap-2">
                            <button style="background-color: #226CE0; color: white; padding: 6px 16px; border: none; border-radius: 4px; display: flex; align-items: center; gap: 6px; height: 38px;" (click)="applyFilters()">
                                <i class="fa fa-search"></i> {{ translation.t('common','search') }}
                            </button>
                            <button style="background-color: #6c757d; color: white; padding: 6px 16px; border: none; border-radius: 4px; display: flex; align-items: center; gap: 6px; height: 38px;" (click)="clearFilters()">
                                <i class="fa fa-times"></i> {{ translation.t('common','clear') }}
                            </button>
                        </div>
                    </div>
                </div>

                <div *ngIf="complaints.data.length > 0; else searchNoResults">
                    <div style="overflow-x: auto;">
                        <table mat-table [dataSource]="complaints" class="mat-elevation-z8" style="width: 100%;">
        
                            <!-- ID Column -->
                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'srNo') }}</th>
                                <td mat-cell *matCellDef="let element; let i = index">{{ (paginator.pageIndex * paginator.pageSize) + i + 1 }}</td>
                            </ng-container>
        
                            <!-- Ticket Id Column -->
                            <ng-container matColumnDef="ticket_id">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'ticketId') }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.ticket_id }}</td>
                            </ng-container>
        
                            <!-- Department Column -->
                            <ng-container matColumnDef="department">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'department') }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.departments }}</td>
                            </ng-container>
        
                            <!-- Zone Column -->
                            <ng-container matColumnDef="zone">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'zone') }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.zone }}</td>
                            </ng-container>
        
                            <!-- Full Name Column -->
                            <ng-container matColumnDef="fullName">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'fullName') }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.full_name }}</td>
                            </ng-container>
        
                            <!-- Mobile No Column -->
                            <ng-container matColumnDef="mobileNo">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'mobileNo') }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.mobile_no }}</td>
                            </ng-container>
        
                            <!-- Date & Time Column -->
                            <ng-container matColumnDef="dateTime">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'createdDate') }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.create_date }}</td>
                            </ng-container>
        
                            <!-- Days Open Column -->
                            <ng-container matColumnDef="days_open">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'daysOpen') }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.number_of_open_days }}</td>
                            </ng-container>
        
                            <!-- Status Column -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'status') }}</th>
                                <td mat-cell *matCellDef="let element">{{ element.status}}</td>
                            </ng-container>
        
        
                            <!-- Action Column -->
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef>{{ translation.t('officerComplaints', 'action') }}</th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <h6 style="color: rgb(0, 26, 255); text-decoration: underline; cursor: pointer;"
                                            class="mt-2 view" (click)="route(element)" matTooltip="View detailed information">
                                            {{ translation.t('officerComplaints', 'viewMore') }}
                                        </h6>
        
        
                                        <mat-icon
                                            style="cursor: pointer; vertical-align: middle; margin-left: 10px; color: rgb(0, 26, 255);"
                                            class="more-options-icon" [matMenuTriggerFor]="menu" matTooltip="More options">
                                            more_vert
                                        </mat-icon>
                                    </div>
        
        
                                    <mat-menu #menu="matMenu">
        
                                        <h6 mat-menu-item (click)="onDownloadPDF(element)">
                                            <span
                                                style="color: rgb(1, 159, 244); text-decoration: underline;cursor: pointer; font-size: 14px;">{{ translation.t('officerComplaints', 'printForm') }}</span>
                                        </h6>
                                    </mat-menu>
                                </td>
                            </ng-container>
                            <!-- Table Headers and Rows -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center py-3" colspan="8">
                                    {{ translation.t('officerDashboard', 'recordsNotFound') }}
                                </td>
                            </tr>
        
                        </table>
                    </div>
                </div>
            </div>
                        <div class="paginator-wrapper">

            <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons
                aria-label="Select page of periodic elements"
                style="margin-top: 20px; margin-bottom: 20px; align-items: center;">
            </mat-paginator></div>
        </div>

        <ng-template #searchNoResults>
            <div class="text-center my-4" style="font-size: 18px; color: gray;">
                {{ translation.t('officerDashboard', 'recordsNotFound') }}
            </div>
        </ng-template>

        <ng-template #noData>
            <div class="text-center my-4" style="font-size: 18px; color: gray;">
                {{ translation.t('officerDashboard', 'recordsNotFound') }}
            </div>
        </ng-template>
    </div>
</div>